import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SavingsSnapshotImg from '../../../assets/savings-snapshot1.png';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button/Button';
import Link from '../../../components/Link';
import GenericCard from '../../../components/GenericCards/GenericCards';
import { SAVINGS_SUMMARY } from '../../../routes/types';
import { formatPrice } from '../../../utils/utils';
import useMobile from '../../../hooks/useMobileHook';

const SavingsSnapshot = ({
  savingsSnapshot,
  title = 'Savings Snapshot',
  withoutContent = false,
}: any) => {
  const navigate = useNavigate();

  return (
    <Col className="p-0 col-12">
      <Col className="p-0">
        <Row className="m-0">
          <Col className="p-0 col-12 d-flex justify-content-between">
            <h4 className="m-0 text-sm-20-lg-32 lh-xs">{title}</h4>

            <Button
              variant="primary-outline"
              rightIcon={light('chevron-right')}
              size="sm"
              onClick={() => window.open('https://workplace.schwab.com/', '_blank')}
              className="align-self-center"
            >
              Details
            </Button>




          </Col>
        </Row>
        <GenericCard className="mt-7 mt-lg-10" variant="white">
          {savingsSnapshot ? (
            <>
              <Row className="m-0 px-6 px-lg-0">
                <div className="p-0 text-sub1 fw-light lh-xxs">
                  <span>Total Balance</span>
                </div>
                <div className="p-0 fw-light lh-xxs mt-3">
                  <h5 className="p-0">$540,865.90</h5>
                </div>
              </Row>

              <Row className="m-0 px-6 px-lg-0 mt-lg-10">
                <Row className="p-0 m-0 mb-3 pb-3 border-bottom">
                  <Col className="col-5 ps-0 text-start text-sm-12-lg-14 fw-normal text-ligther-grey">
                    Plan
                  </Col>
                  <Col className="col-3 text-start text-sm-12-lg-14 fw-normal text-ligther-grey">
                    Balance
                  </Col>
                  <Col className="col-4 pe-0 text-end text-sm-12-lg-14 fw-normal text-ligther-grey">
                    ROR
                  </Col>
                </Row>
                {savingsSnapshot.map((snapshot: any, index: number) => (
                  <Row
                    key={index}
                    className={`px-0 mx-0 pb-3 ${
                      savingsSnapshot.length - 1 === index
                        ? ''
                        : 'mb-3 border-bottom'
                    }`}
                  >
                    <Col className="col-5 ps-0 text-start text-primary text-sm-12-lg-14 fw-normal">
                      {snapshot.title}
                    </Col>
                    <Col className="col-3 mt-6 mt-lg-0 text-start text-sm-12-lg-14 fw-normal">
                      {`${formatPrice(Number(snapshot.amount), 'en-US', {
                        currency: 'USD',
                        style: 'currency',
                        minimumFractionDigits: 2,
                      })}`}
                    </Col>
                    <Col
                      className={`col-4 mt-6 mt-lg-0 pe-0 text-end text-sm-12-lg-14 fw-normal ${
                        snapshot.percentRor < 0 ? 'text-danger-dark' : null
                      } `}
                    >
                      {`${snapshot.percentRor}%`}
                    </Col>
                  </Row>
                ))}
              </Row>
              <Row className="m-0 px-6 px-lg-0 mt-7">
                <Blockquote variant="primary">
                  <div className="fw-light text-sub1">
                    You are fully vested!
                  </div>
                </Blockquote>
              </Row>
            </>
          ) : (
            <Row className="m-0 py-11">
              <Col className="p-0 d-flex flex-column justify-content-lg-center">
                <div className="d-flex justify-content-center justify-content-lg-start">
                  <h5 className="m-0 fw-normal">Savings Enrollment</h5>
                </div>
                <div className="mt-1 d-flex justify-content-center justify-content-lg-start fw-light text-sub1 text-darker lh-xs">
                  <span>
                    You have no active plans at the moment. It is never to early
                    to start saving for retirement. Enrolling in the 401(k) plan
                    is quick and easy.
                  </span>
                </div>
                <div className="mt-10 d-flex justify-content-center justify-content-lg-start">
                  <Button
                    onClick={() => navigate(SAVINGS_SUMMARY)}
                    variant="primary-outline"
                    className={'order-1 order-lg-3 mt-3 mt-lg-0 me-7'}
                    size="sm"
                  >
                    Learn more
                  </Button>
                  <Button
                    variant="primary"
                    className={'order-1 order-lg-3 mt-3 mt-lg-0'}
                    size="sm"
                  >
                    Enroll Now
                  </Button>
                </div>
              </Col>
              <Col className="p-0 mt-7 mt-lg-0 d-flex flex-column align-items-center">
                <img src={SavingsSnapshotImg} alt="savings-snapshot-img" />
              </Col>
            </Row>
          )}
        </GenericCard>
      </Col>
    </Col>
  );
};

export default SavingsSnapshot;
